import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/apps/product-plus/search-domain/pipelines/player-data/response-factory';
import { type PlayerDataSearchResponseBody } from '~/apps/product-plus/search-domain/pipelines/player-data/types';
import { type SearchDomainContext, type SearchPipelineEnrichments } from '~/apps/product-plus/search-domain/types';

export async function transformPlayerDataResponse(
  _context: SearchDomainContext,
  {
    enrichments,
    searchResponse,
  }: {
    enrichments?: SearchPipelineEnrichments;
    searchRequest: SearchRequest;
    searchResponse: unknown;
  },
) {
  return createResponseFactory(searchResponse as PlayerDataSearchResponseBody, enrichments?.bookmakerCountsByBetId);
}
